import type { RoomStockInput, StockHeaderItemInput } from "@/lib/gql/__generated__/graphql";

import type { RoomStockDiffStore } from "../../../../usecase/use-create-form-model/room-stock-diff-store";
import type { ServerModel } from "../../../../usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	roomStockDiffStore: RoomStockDiffStore;
};

export const convertToViewModelToInput = ({ serverModel, roomStockDiffStore }: Props) => {
	const input = {
		hotelID: serverModel.roomStock.hotelID,
		headers: serverModel.roomStock.headers.map(
			(header) =>
				({
					date: header.date,
				}) satisfies StockHeaderItemInput,
		),
		items: roomStockDiffStore.getDiffItems(),
	} satisfies RoomStockInput;

	return input;
};
